import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/apiClient";

export function useSettings() {
  return useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
    staleTime: 5 * 60 * 1000,
  });
}
